
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/f/custody-whitepaper/l",
      function () {
        return require("private-next-pages/f/custody-whitepaper/l.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/f/custody-whitepaper/l"])
      });
    }
  